import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Wrapper from '../layouts/Wrapper';
import Banner from '../components/aboutUs/Banner';
import OurMission from '../components/aboutUs/OurMission';
// import OurValues from '../components/aboutUs/OurValues';
// import OurGoals from '../components/aboutUs/OurGoals';
// import OurTeam from '../components/home/OurTeam';
import OurPartners from '../components/home/OurPartners';
import { getAboutUsPage } from '../store/actions/aboutPage';
import Spinner from '../components/Spinner';
import OurTeam from '../components/home/OurTeam';

function AboutUs() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.aboutPage);
  useEffect(() => {
    dispatch(getAboutUsPage());
  }, []);
  return (
    <Wrapper>
      {!loading ? (
        <div className="about-us">
          <Banner
            way={data.aboutUs.two_blog_title[lang]}
            title={data.aboutUs.title[lang]}
            description={data.aboutUs.description[lang]}
            body={data.aboutUs.body[lang]}
            image={data.aboutUs.image.webp_url}
          />
          <OurMission
            ourMissionTitle={data.aboutUs.our_mission_title[lang]}
            ourMissionDescription={data.aboutUs.our_mission_description[lang]}
            ourVisionTitle={data.aboutUs.our_vision_title[lang]}
            ourVisionDescription={data.aboutUs.our_vision_description[lang]}
          />
          {/* <OurValues */}
          {/*  data={data.ourValues} */}
          {/*  title={data.aboutUs.our_values_title[lang]} */}
          {/*  description={data.aboutUs.our_values_description[lang]} */}
          {/* /> */}
          {/* <OurGoals */}
          {/*  data={data.ourGoals} */}
          {/*  title={data.aboutUs.our_goals_title[lang]} */}
          {/*  description={data.aboutUs.our_goals_description[lang]} */}
          {/* /> */}
          <OurTeam data={data.all_staff} />
          <OurPartners data={data.partners} />
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default AboutUs;
